import React from 'react';
import {
  BooleanField,
  BooleanInput,
  DateField,
  Edit,
  EditButton,
  Filter,
  List,
  NullableBooleanInput,
  NumberField,
  SearchInput,
  SelectInput,
  Show,
  TextField,
  TextInput,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  ZippityDatagrid,
  ZippitySimpleForm,
  ZippitySimpleShow,
} from '../../components';
import BulkDeleteButton from '../../components/BulkDeleteButton';

const CarFaxRecordFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      alwaysOn
      source="type"
      choices={[
        { id: 'service', name: 'Service' },
        { id: 'recall', name: 'Recall' },
      ]}
    />
    <NullableBooleanInput source="has_recall_been_actioned" />
  </Filter>
);

export const CarFaxRecordList = (props) => (
  <List
    {...props}
    filters={<CarFaxRecordFilter />}
    bulkActionButtons={<BulkDeleteButton />}
    sort={{ field: 'vin', order: 'ASC' }}
    perPage={50}
  >
    <ZippityDatagrid rowClick="show">
      <DateField source="created_at" />
      <DateField source="modified_at" />
      <TextField source="carfax_record_id" />
      <TextField source="vin" />
      <NumberField source="mileage" />
      <DateField source="date" />
      <TextField source="type" />
      <TextField source="completed_services" />
      <TextField source="recall_information" />
      <BooleanField source="has_recall_been_actioned" />
      <TextField source="recall_action_internal_note" />
      <EditButton />
    </ZippityDatagrid>
  </List>
);

export const CarFaxRecordShow = (props) => (
  <Show {...props}>
    <ZippitySimpleShow>
      <DateField source="created_at" />
      <DateField source="modified_at" />
      <TextField source="carfax_record_id" />
      <NumberField source="mileage" />
      <TextField source="vin" />
      <DateField source="date" />
      <TextField source="type" />
      <TextField source="completed_services" />
      <TextField source="recall_information" />
      <BooleanField source="has_recall_been_actioned" />
      <TextField source="recall_action_internal_note" />
    </ZippitySimpleShow>
  </Show>
);

const editStyles = { textInputWide: { width: '100%' } };

export const CarFaxRecordEdit = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Edit undoable={false} {...props}>
      <ZippitySimpleForm>
        <NumberField source="mileage" />
        <TextField source="vin" />
        <DateField source="date" />
        <TextField source="type" />
        <TextField source="completed_services" />
        <TextField source="recall_information" />
        <BooleanInput source="has_recall_been_actioned" />
        <TextInput
          source="recall_action_internal_note"
          className={classes.textInputWide}
        />
      </ZippitySimpleForm>
    </Edit>
  ),
);
